import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";
import { IInvitation, IUser, USER_SOURCE } from "../../@core/models/model";
import { USER_ROLE } from "src/app/@core/models/enums";

@Injectable({ providedIn: 'root' })
export class InvitationService extends BaseService {

    apiUrl = environment.apiUrl + '/invite';
    authUrl = environment.apiUrl + '/authentication';

    constructor(protected override http: HttpClient) {
        super(http);
    }

    getInviteDetails(inviteId: string) {
        return this.get<{ invitation: IInvitation, userLimitExceeded: boolean }>(this.authUrl + `/invite-details/${inviteId}`);
    }

    getInvites() {
        return this.get<IInvitation[]>(this.apiUrl);
    }

    deleteInvite(inviteId: string) {
        return this.delete(this.apiUrl + `/${inviteId}`);
    }

    sendInvite(data: { email: string, role: USER_ROLE, planId?: string, requestId?: string }[], source: USER_SOURCE) {
        return this.post<{ requiresPayment?: boolean, checkoutUrl?: string, message?: string }>(this.apiUrl, { data, source });
    }

    updateInviteUser(invite: IInvitation) {
        return this.put(this.apiUrl, { invite });
    }

    checkEmailExists(email: string) {
        return this.get<{
            exists: boolean,
            message: string
        }>(this.apiUrl + `/check-email`, { email })
    }

    resendInvite(userId: string, role: string, email: string, organizationId: string) {
        return this.post(this.apiUrl + `/resend-invite`, { userId, role, email, organizationId });
    }
}
